import * as Yup from 'yup';
import { validatePhone } from 'validations-br';
import isValidCNPJ, { normalizeCNPJ } from '@utils/cnpj_validator';

export default function buildValidations(template) {
  const validationMessages = template.validations;

  const schema = Yup.object().shape({
    registry_code: Yup.string()
      .required(validationMessages.default.required)
      .test('cnpj-format', 'O CNPJ deve conter 14 caracteres', (value) => {
        if (!value) return true;
        return normalizeCNPJ(value).length === 14;
      })
      .test('cnpj-valid', validationMessages.registry_code.format, (value) => {
        if (!value) return true;
        return isValidCNPJ(value);
      })
      .test('cnpj-sequential', 'CNPJ com dígitos sequenciais é inválido', (value) => {
        if (!value) return true;
        return !/^(\d)\1+$/.test(normalizeCNPJ(value));
      }),
    user_email: Yup.string()
      .email(validationMessages.user_email.format)
      .required(validationMessages.default.required),
    user_name: Yup.string().required(validationMessages.default.required),
    phone_number: Yup.string()
      .required(validationMessages.default.required)
      .test('is-phone', validationMessages.phone_number.format, (value) => validatePhone(String(value))),
    company_name: Yup.string().required(validationMessages.default.required),
  });

  return schema;
}
